import { instance } from 'src/apis/index';

export const apiParking = {
  getParkingInfo: (festivalId: number) =>
    instance.get(`/parking?festivalId=${festivalId}`),
};
